/**
 * LegalShell — shared layout for public legal / info pages.
 *
 * A minimal top-nav (brand + right-side auth CTAs), the main content in a
 * comfortable reading column, and the shared SiteFooter. Zero authentication
 * dependency — these pages render for anonymous visitors and crawlers.
 */
import { Link } from "react-router-dom";
import SiteFooter from "@/components/SiteFooter";

export default function LegalShell({ children, eyebrow, title, subtitle, testid }) {
    return (
        <div className="min-h-screen bg-paper flex flex-col" data-testid={testid || "legal-shell"}>
            <header className="border-b border-lexiBorder bg-white">
                <div className="max-w-4xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8 py-4">
                    <Link to="/" className="font-serif text-lg" data-testid="legal-brand">
                        Lexia School
                    </Link>
                    <nav className="flex items-center gap-4 text-sm">
                        <Link to="/login" className="text-inkSoft hover:text-ink" data-testid="legal-login">
                            Se connecter
                        </Link>
                        <Link
                            to="/register"
                            className="bg-terracotta hover:bg-terracottaDark text-white rounded-full px-4 py-1.5 transition-colors"
                            data-testid="legal-register"
                        >
                            Créer mon compte
                        </Link>
                    </nav>
                </div>
            </header>

            <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
                {eyebrow && (
                    <p className="text-xs tracking-[0.28em] uppercase text-inkSoft mb-3">
                        {eyebrow}
                    </p>
                )}
                {title && (
                    <h1 className="font-serif text-3xl md:text-4xl leading-tight" data-testid="legal-title">
                        {title}
                    </h1>
                )}
                {subtitle && (
                    <p className="mt-3 text-inkSoft max-w-2xl" data-testid="legal-subtitle">
                        {subtitle}
                    </p>
                )}
                <div className="mt-8 space-y-6">
                    {children}
                </div>
            </main>

            <SiteFooter />
        </div>
    );
}
